import MultiDigitInput from './MultiDigitInput';
export default MultiDigitInput;
